import React from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useAudioPlayer } from "@/contexts/AudioPlayerContext";
import SwipeableQueueItem from "../AudioPlayer/SwipeableQueueItem";

const BookmarkedHistory = () => {
  const { currentEpisode, bookmarkedEpisodes, playEpisode, toggleBookmark } =
    useAudioPlayer();

  const handlePlayEpisode = (episode: Episode) => {
    // Find the index of the clicked episode
    const episodeIndex = bookmarkedEpisodes.findIndex(ep => ep.id === episode.id);
    if (episodeIndex === -1) return;

    // Get the remaining episodes starting from the clicked one
    const remainingEpisodes = bookmarkedEpisodes.slice(episodeIndex + 1);
    console.log('Setting up bookmarked history queue with remaining episodes:', remainingEpisodes.length);

    // Set up the queue with remaining episodes
    // setQueueEpisodes(remainingEpisodes);
    // setDisplayedEpisodes(remainingEpisodes);
    
    // Play the selected episode with history reset
    playEpisode(episode, false, { resetHistory: true });
  };

  if (bookmarkedEpisodes.length === 0) {
    return (
      <div className="w-full bg-white/20 backdrop-blur-md rounded-3xl border border-white/20 shadow-xl overflow-hidden">
        <div className="p-6 flex flex-col items-center justify-center">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            Bookmarked Episodes
          </h2>
          <p className="text-gray-600">No bookmarked episodes yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-white/20 backdrop-blur-md rounded-3xl border border-white/20 shadow-xl overflow-hidden flex flex-col h-full">
      <div className="flex-none px-4 py-3 border-b border-white/5">
        <h2 className="text-sm font-medium text-gray-800">
          Bookmarked Episodes
        </h2>
      </div>
      <ScrollArea className="flex-1">
        <div className="divide-y divide-white/5">
          {bookmarkedEpisodes.map((episode) => (
            <SwipeableQueueItem
              key={episode.id}
              title={episode.title}
              duration={episode.duration}
              artist={episode.podcastName}
              imageUrl={episode.imageUrl}
              listens={episode.listens}
              likes={episode.likes}
              isActive={episode.id === currentEpisode?.id}
              isBookmarked={true}
              onClick={() => handlePlayEpisode(episode)}
              onBookmark={() => toggleBookmark(episode.id)}
              onDelete={() => toggleBookmark(episode.id)}
            />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};

export default BookmarkedHistory;
